import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";

function CardTypesCtl(props)
{
	return (<>
		{/* <div ref={props.formRef} style={{display: "none"}}>
			<Row form>
				<Col md="12">
					<FormGroup>
						<Label for="cardTypeId">Gift card type</Label>
						<Input innerRef={props.cardTypeInputRef} type="select" name="cardTypeId" id="cardTypeId">
							<option value="-1">Select a gift card type</option>
						</Input>
					</FormGroup>
				</Col>
			</Row>
			
		</div> */}
		<Row form>
			<Col md="12" className="justify-content-end text-right">
				<Button type="button" className="btn btn-primaryTwo" onClick={props.onAdd}>Add card type</Button>
			</Col>
		</Row>
	</>);
}

export default CardTypesCtl;